<body>
<section  class="sign-in-btns"> 
    <div  class="sign-in-info">
    <app-page-title pageTitle='Village of Volo Overnight Parking'></app-page-title><br>
    <div class="button-wrapper">
    <div style="clear: both;margin-right: 10px;"><button mat-button class="button-primary btn-login"  (click)="gotoAdmin()" type="submit" color="vov-ui-primary">Admin</button></div>
    <div style="clear: both;margin-right: 10px;"><button mat-button class="button-primary btn-login" (click)="gotoVillageStaff()" type="submit" color="vov-ui-primary">Village Staff</button></div>
    <div style="clear: both;margin-right: 10px;"><button mat-button class="button-primary btn-login" (click)="gotoOfficer()" type="submit" color="vov-ui-primary">Officer</button></div>
  </div>
    <!-- <button  (click)="gotoAdmin()">Admin</button>
    <button  (click)="gotoVillageStaff()">Village staff</button>
    <button  (click)="gotoOfficer()">Officer</button> -->
    <!-- <div class="nav-link"><span style="padding-right: 10px;" class="txt-black">Having Trouble?</span>Get Help</div> -->
  </div>
  </section>
</body>